module.exports = __webpack_public_path__ + "5c8d3def0d2387cbc46b9f4c7cfbffa0.svg";